import { userApis } from "@payping/api";
import { getUserChecks } from "@payping/redux/actions";
import { Trans } from "@payping/utils/localeUtils";
import { webConstants } from "@payping/utils/platformConstants";
import { Button, Checkbox, Modal } from "@payping/web-components";
import React, { useEffect } from "react";
import { useAsyncFn } from "react-use";

import { useAppDispatch, useAppSelector } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { TaxConsentProps } from "@/pages/OverviewTab/Profile/TaxConsent/types";

const TaxConsent: React.FC<TaxConsentProps> = (props: TaxConsentProps) => {
  const { visible, setVisibleConsent } = props;
  const { t } = useAppTranslation();
  const checks = useAppSelector((state) => state.user.checks);
  const [agreementAccepted, setAgreementAccepted] = React.useState(false);
  const dispatch = useAppDispatch();
  const { HELP_URL, TERMS_URL } = webConstants;

  const [{ loading }, handleOk] = useAsyncFn(async () => {
    await userApis.acceptAgreementGet();
    dispatch(getUserChecks());
    setVisibleConsent(false);
  }, []);

  const onChangeCheck = (e: any) => {
    setAgreementAccepted(e.target.checked);
  };

  useEffect(() => {
    if (checks?.agreementAccepted === false) setVisibleConsent(true);
  }, [checks, setVisibleConsent]);

  return (
    <>
      <Modal
        title={t("taxModal.title")}
        open={visible}
        centered
        footer={
          <Button
            loading={loading}
            className="w-100"
            disabled={!agreementAccepted}
            variant={"primary"}
            onClick={handleOk}
          >
            {t("taxModal.CTA")}
          </Button>
        }
        confirmLoading={loading}
        onCancel={() => setVisibleConsent(false)}
      >
        <p className="text-justify">
          <Trans
            i18nKey={"Wrapper:taxModal.description"}
            components={[
              <a key="0" target="_blank" rel="noreferrer" href={HELP_URL} />,
              <a key="1" target="_blank" rel="noreferrer" href={TERMS_URL} />,
            ]}
          />
        </p>
        <br />
        <Checkbox onChange={onChangeCheck} className="justify-start">
          {t("taxModal.consentCheck")}
        </Checkbox>
      </Modal>
    </>
  );
};

export default TaxConsent;
